import {useAdministrativeDivisions} from "snimf/location/provider";

import {FormDatePicker, FormSelect} from "base/form/components";
import Grid from "@mui/material/Grid";

const PermitApplicationInitialFormFields = () => {
    const {userDistricts} = useAdministrativeDivisions();
    const MIN_DATE = new Date(1990, 0, 1);
    const MAX_DATE = new Date(2099, 11, 31);
    return (
        <Grid container columnSpacing={1}>
            <Grid item xs={6}>
                <FormDatePicker
                    name="application_date"
                    label="Data de solicitação"
                    rules={{required: "Este campo é obrigatório."}}
                    // minDate={MAX_DATE}
                    // maxDate={MIN_DATE}
                />
            </Grid>
            <Grid item xs={6}>
                <FormSelect
                    name="district"
                    label="Distrito"
                    options={userDistricts}
                    rules={{required: "Este campo é obrigatório."}}
                />
            </Grid>
        </Grid>
    );
};

export default PermitApplicationInitialFormFields;
